import('./bootstrap');

export default function Module() {
  return <></>;
}
